import { Component, computed, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { ButtonComponent } from '@bn/web-ui/button';
import { DropdownMenuItem } from '@bn/web-ui/dropdown-menu';
import { DropdownMenuComponent } from '@bn/web-ui/dropdown-menu/dropdown-menu.component';
import { EVENT_LOG_DIMENSION_MAP, EVENT_LOG_DIMENSIONS, EventLogDimensionMeta } from '../../../../models';

@Component({
  selector: 'app-app-shield-event-logs-group-by',
  templateUrl: './event-logs-group-by.component.html',
  styleUrls: ['./event-logs-group-by.component.scss'],
  imports: [BadgeComponent, ButtonComponent, DropdownMenuComponent, FaIconComponent],
})
export class EventLogsGroupByComponent {
  readonly groupByDims = input<string[]>([]);

  readonly groupByChange = output<string[]>();

  readonly activeDims = computed<EventLogDimensionMeta[]>(() =>
    this.groupByDims()
      .map((dim) => EVENT_LOG_DIMENSION_MAP[dim])
      .filter((dim): dim is EventLogDimensionMeta => !!dim),
  );

  readonly inactiveDims = computed<EventLogDimensionMeta[]>(() => this.#groupableDims.filter((dimension) => !this.groupByDims().includes(dimension.dimension)));

  readonly menuItems = computed<DropdownMenuItem[]>(() => {
    const items: DropdownMenuItem[] = this.inactiveDims().map((dimension) => ({
      label: dimension.label,
      icon: dimension.icon,
      action: 'add',
      id: dimension.dimension,
    }));

    if (this.activeDims().length) {
      items.push({ type: 'divider' }, { label: 'Clear all', icon: 'xmark', action: 'clear', contextType: 'info' });
    }

    return items;
  });

  readonly #groupableDims: EventLogDimensionMeta[] = EVENT_LOG_DIMENSIONS.filter((dimension) => dimension.groupable);

  onMenuAction(item: DropdownMenuItem): void {
    if (item.action === 'add') this.add(String(item.id));
    else if (item.action === 'clear') this.clear();
  }

  add(dimension: string): void {
    this.groupByChange.emit([...this.groupByDims(), dimension]);
  }

  remove(dimension: string): void {
    this.groupByChange.emit(this.groupByDims().filter((dim) => dim !== dimension));
  }

  moveUp(index: number): void {
    if (index <= 0) return;

    this.groupByChange.emit(this.#swap(index, index - 1));
  }

  moveDown(index: number): void {
    if (index >= this.groupByDims().length - 1) return;

    this.groupByChange.emit(this.#swap(index, index + 1));
  }

  clear(): void {
    this.groupByChange.emit([]);
  }

  #swap(first: number, second: number): string[] {
    const dims = [...this.groupByDims()];
    [dims[first], dims[second]] = [dims[second], dims[first]];

    return dims;
  }
}
